import React from 'react';
import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { BoxMenuTitle, BoxMenyIconContainer, StyledCard, StyledIcon } from './box-menu.style';
import themes from './themes';
import { ThemeOverride } from '@plasma/ui.utils.types';
 
interface BoxMenuProps {
  icon: string;
  iconSize: string;
  boxHeight: string;
  boxWidth: string;
  title: any;
  titleFontSize: string;
  onBoxClick: (title: string) => void;
  disabled: boolean;
}
 
type Props = BoxMenuProps & ThemeOverride;
 
function BoxMenu(props: Props) {
  const { themeMode, icon, iconSize, title, titleFontSize, disabled } = props;
 
  const handleClick = () => {
    props.onBoxClick(title);
  };
 
 
  return (
    <ThemeProvider themes={themes} selectedMode={themeMode}>
        <StyledCard disabled={disabled}
          onClick={handleClick}
          border={{type:'full'}}
        >
          <div>
            <BoxMenyIconContainer>
                <StyledIcon name={icon} iconSize={iconSize} />
             </BoxMenyIconContainer>
            <hr></hr>
            {title && <BoxMenuTitle fontSize={titleFontSize}>{title}</BoxMenuTitle>}
          </div>
 
        </StyledCard>
 
    </ThemeProvider>
  );
}
 
export default BoxMenu;